import { enumType } from '@shared/core/types/common';

enum CLEAR_ON_IDLE_TRIGGER_MODE {
    CLEAR_ON_TIMEOUT = 0,
    ASK_CLEAR_ON_TIMEOUT = 1,
}

enum CLEAR_ON_IDLE_USER_TYPE {
    MEMBER = 0,
    GUEST = 1,
    BOTH = 2,
}

export const clearOnIdleTriggerModeEnum = enumType('CLEAR_ON_IDLE_TRIGGER_MODE', CLEAR_ON_IDLE_TRIGGER_MODE);
export const clearOnIdleUserTypeEnum = enumType('CLEAR_ON_IDLE_USER_TYPE', CLEAR_ON_IDLE_USER_TYPE);
